import { render, staticRenderFns } from "./DriveFileRow.vue?vue&type=template&id=38c3747e&scoped=true"
import script from "./DriveFileRow.vue?vue&type=script&lang=js"
export * from "./DriveFileRow.vue?vue&type=script&lang=js"
import style0 from "./DriveFileRow.vue?vue&type=style&index=0&id=38c3747e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3747e",
  null
  
)

export default component.exports